import React, { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { colors, radius, shadows, spacing } from '../styles/theme';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [focusField, setFocusField] = useState(null);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const success = await login(email, password);
    if (!success) {
      setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
    setLoading(false);
  };

  const inputStyle = (field) => ({
    width: '100%',
    padding: '14px 16px',
    border: `2px solid ${focusField === field ? colors.primary : colors.border}`,
    borderRadius: radius.md,
    fontSize: '15px',
    fontFamily: 'inherit',
    color: colors.textPrimary,
    background: colors.surface,
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    boxShadow: focusField === field ? shadows.glow : 'none',
  });

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-40px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.7; }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .login-btn:hover:not(:disabled) {
          background: ${colors.primaryDark} !important;
          transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(198, 40, 40, 0.35);
        }
        .login-btn:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(198, 40, 40, 0.25);
        }
        .login-input::placeholder {
          color: ${colors.textTertiary};
        }
        @media (max-width: 768px) {
          .login-brand-panel { display: none !important; }
          .login-form-panel { width: 100% !important; }
        }
      `}</style>

      <div style={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        background: colors.background,
      }}>
        {/* Brand Panel — Left */}
        <div className="login-brand-panel" style={{
          width: '48%',
          background: `linear-gradient(145deg, ${colors.secondary} 0%, ${colors.primaryDark} 50%, ${colors.primary} 100%)`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Decorative elements */}
          <div style={{
            position: 'absolute', top: '-20%', right: '-10%',
            width: '500px', height: '500px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
          }} />
          <div style={{
            position: 'absolute', bottom: '-15%', left: '-8%',
            width: '400px', height: '400px', borderRadius: '50%',
            background: 'rgba(255,255,255,0.02)',
          }} />
          {/* Diagonal lines pattern */}
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `repeating-linear-gradient(
              -45deg, transparent, transparent 80px,
              rgba(255,255,255,0.015) 80px, rgba(255,255,255,0.015) 81px
            )`,
          }} />

          {/* Brand Content */}
          <div style={{
            position: 'relative', zIndex: 1,
            textAlign: 'center', padding: '40px',
            animation: 'slideInLeft 0.8s ease-out',
          }}>
            {/* Logo mark */}
            <div style={{
              width: '88px', height: '88px',
              borderRadius: '20px',
              background: 'rgba(255,255,255,0.12)',
              backdropFilter: 'blur(20px)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 28px',
              border: '1px solid rgba(255,255,255,0.15)',
              fontSize: '42px',
            }}>
              T
            </div>

            <h1 style={{
              color: '#ffffff',
              fontSize: '36px',
              fontWeight: '800',
              letterSpacing: '-0.03em',
              margin: '0 0 8px',
              lineHeight: '1.1',
            }}>
              TORUNA
            </h1>
            <div style={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: '13px',
              fontWeight: '500',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '40px',
            }}>
              GIDA &middot; ERP
            </div>

            {/* Stats row */}
            <div style={{
              display: 'flex', gap: '32px', justifyContent: 'center',
              borderTop: '1px solid rgba(255,255,255,0.1)',
              paddingTop: '32px',
            }}>
              {[
                { val: '3', label: 'Firma' },
                { val: '5', label: 'Lokasyon' },
                { val: '12', label: 'Kullanıcı' },
              ].map((s) => (
                <div key={s.label} style={{ textAlign: 'center' }}>
                  <div style={{ color: '#fff', fontSize: '24px', fontWeight: '700' }}>{s.val}</div>
                  <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', fontWeight: '500', letterSpacing: '0.05em', marginTop: '4px' }}>
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom info */}
          <div style={{
            position: 'absolute', bottom: '24px',
            color: 'rgba(255,255,255,0.25)',
            fontSize: '11px',
            letterSpacing: '0.04em',
          }}>
            Toruna Gıda &middot; Inga Burger &middot; Altı Üstü Köfte
          </div>
        </div>

        {/* Form Panel — Right */}
        <div className="login-form-panel" style={{
          width: '52%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: colors.surface,
          padding: spacing['3xl'],
        }}>
          <div style={{
            width: '100%',
            maxWidth: '380px',
            animation: 'fadeInUp 0.6s ease-out',
          }}>
            {/* Mobile logo (hidden on desktop via brand panel) */}
            <div style={{
              textAlign: 'center',
              marginBottom: '32px',
            }}>
              <h2 style={{
                margin: '0 0 6px',
                fontSize: '24px',
                fontWeight: '700',
                color: colors.textPrimary,
                letterSpacing: '-0.02em',
              }}>
                Hoş Geldiniz
              </h2>
              <p style={{
                margin: 0,
                color: colors.textSecondary,
                fontSize: '14px',
              }}>
                Hesabınıza giriş yapın
              </p>
            </div>

            {/* Error */}
            {error && (
              <div style={{
                background: colors.dangerLight,
                color: '#991b1b',
                padding: '12px 16px',
                borderRadius: radius.md,
                marginBottom: spacing.lg,
                fontSize: '13px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                border: `1px solid ${colors.danger}20`,
              }}>
                <span style={{ flexShrink: 0 }}>&#9888;</span>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Email */}
              <div style={{ marginBottom: spacing.lg }}>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  color: colors.textSecondary,
                }}>
                  E-Posta
                </label>
                <input
                  className="login-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => setFocusField('email')}
                  onBlur={() => setFocusField(null)}
                  required
                  style={inputStyle('email')}
                  placeholder="ornek@toruna.com"
                />
              </div>

              {/* Password */}
              <div style={{ marginBottom: spacing['2xl'] }}>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  color: colors.textSecondary,
                }}>
                  Şifre
                </label>
                <input
                  className="login-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => setFocusField('password')}
                  onBlur={() => setFocusField(null)}
                  required
                  style={inputStyle('password')}
                  placeholder="Şifrenizi girin"
                />
              </div>

              {/* Submit */}
              <button
                className="login-btn"
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: colors.primary,
                  color: colors.textOnPrimary,
                  border: 'none',
                  borderRadius: radius.md,
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  transition: 'all 0.2s',
                  letterSpacing: '0.02em',
                  fontFamily: 'inherit',
                }}
              >
                {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
              </button>
            </form>

            {/* Footer */}
            <div style={{
              textAlign: 'center',
              marginTop: spacing['3xl'],
              color: colors.textTertiary,
              fontSize: '12px',
            }}>
              TORUNA ERP &middot; v2.0
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
